import React, { useState, useEffect, useRef, useContext, useCallback, memo } from 'react';
import "./listeElementsRecherche.css";
import { Fragment } from 'react';
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
import RechercheContext from './RechercheContext';
import Helper from '../../utils/helper';
import { AutoComplete } from 'primereact/autocomplete';
import { useTranslation } from 'react-i18next';
import { debounce } from '../../utils/performanceUtils';


const ListeElementsRechercheComponent = (props) => {

    const {t} = useTranslation();
    const contextRecherche = useContext(RechercheContext);
    const [filteredValues, setFilteredValues] = useState(null);
    const [selectedValues, setSelectedValues] = useState(null);

    const handleRemoveValeur = (valeur) => {

        let _filters = [...contextRecherche.lazyParams.filters];
        const indexSupprime = Helper.findIndexByValueAndCategorie(_filters, valeur.value, valeur.categorie);
        _filters.splice(indexSupprime, 1);
        // if filter is a school, remove diplomas and trainings
        if (valeur.categorie == contextRecherche.categorieRecherche.Composante || valeur.categorie == contextRecherche.categorieRecherche.Ecole) {
            let _indexToRemove = [];
            // seek diplome and formatio, to remove
            _filters.forEach((element, index) => {
                if (element.categorie == contextRecherche.categorieRecherche.Diplome || element.categorie == contextRecherche.categorieRecherche.Formation) {
                    _indexToRemove.push(index)
                }
            });
            //remove existing filte
            for (var i = _indexToRemove.length - 1; i >= 0; i--) {
                _filters.splice(_indexToRemove[i], 1);
            }
        }
        // if filter is a diploma, remove trainings
       
        if (valeur.categorie == contextRecherche.categorieRecherche.Diplome) {
            let _indexToRemove = [];
            // seek formation, to remove
            _filters.forEach((element, index) => {
                if (element.categorie == element.categorie == contextRecherche.categorieRecherche.Formation) {
                    _indexToRemove.push(index)
                }
            });
            //remove existing filte
            for (var i = _indexToRemove.length - 1; i >= 0; i--) {
                _filters.splice(_indexToRemove[i], 1);
            }
        }
        const _lazyParams = { ...contextRecherche.lazyParams };
        _lazyParams.filters = _filters;

        contextRecherche.setLazyParams(_lazyParams);
        contextRecherche.rechercheApi(_lazyParams);
    }

    const handleRemoveAllValues = () => {
        let _filters = [...contextRecherche.lazyParams.filters];
        _filters = _filters.filter(function( obj ) {
            return props.values.indexOf(obj.categorie) == -1;
        });
        const _lazyParams = { ...contextRecherche.lazyParams };
        _lazyParams.filters = _filters;

        contextRecherche.setLazyParams(_lazyParams);
        contextRecherche.rechercheApi(_lazyParams);
    }

    // Debounce search to avoid too many API calls (min 3 characters)
    const searchValues = useCallback(
        debounce((event) => {
            let query = event.query;
            if (query && query.length >= 3) {
                props.onSearch(query).then(res => setFilteredValues(res));
            }
        }, 400),
        [props.onSearch]
    );

    const handleChange = (value) => {
        setSelectedValues(value);
        if (typeof (value) === 'object') {
            setSelectedValues(null);
        }
        props.onChange(value)

    }

    const template = (item) => {
        return (
            <span className="ler-item" >
                {item.label}
            </span>
        );
    }

    return (
        <div>
            <div className='p-grid'>
                <div className='p-col-12 p-fluid ler-autocomplete-container'>

                    <AutoComplete
                        className='ler-autcomplete'
                        panelClassName="ler-autcomplete-panel"
                        minLength="3"
                        value={selectedValues}
                        suggestions={filteredValues}
                        completeMethod={searchValues}
                        placeholder={props.placeholder}
                        field={props.field}
                        delay="1000"
                        optionGroupLabel={props.optionGroupLabel}
                        optionGroupChildren={props.optionGroupChildren}
                        itemTemplate={template}
                        optionGroupTemplate={template}
                        onChange={(e) => handleChange(e.value)}
                    />

                    {props.icon && <div className='ler-autocomplete-icon'>
                        <i className={props.icon}></i>
                    </div>}

                </div>
                {contextRecherche.lazyParams.filters?.filter(o => props.values.includes(o.categorie)).length > 0 && props.canDeleteAll && props.style !== 'student' && <div className='p-col-12'>
                    <Button
                    className='ler-delete-all'
                    icon="pi pi-times"
                    label={t('search.erase_all')}
                    onClick={(e) => handleRemoveAllValues()}></Button>
                </div>}
                {/* Applied filters rendering with two variants: default (blue/white) and 'student' (OC tags with header only when canDeleteAll) */}
                {contextRecherche.lazyParams.filters?.filter(o => props.values.includes(o.categorie)).length > 0 && (
                    <div className='p-col-12'>
                        {(() => {
                            const applied = contextRecherche.lazyParams.filters
                                ?.filter(o => props.values.includes(o.categorie))
                                ?.sort((a, b) => (a.label > b.label) ? 1 : -1);

                            if (props.style === 'student') {
                                if (props.canDeleteAll) {
                                    return (
                                        <div className="oc-applied-filters-container">
                                            <div className="oc-applied-filters-header">
                                                <small className="oc-applied-filters-count">
                                                    {applied.length} filtre{applied.length > 1 ? 's' : ''} appliqué{applied.length > 1 ? 's' : ''}
                                                </small>
                                                <button 
                                                    className="oc-applied-filters-clear-btn"
                                                    onClick={() => handleRemoveAllValues()}
                                                    title="Effacer tous les filtres de cette catégorie"
                                                >
                                                    <i className="pi pi-times"></i>
                                                    {t('search.all_clear')}
                                                </button>
                                            </div>
                                            <div className="oc-applied-filters-tags">
                                                {applied.map((valeur, indexValeur) => (
                                                    <Button
                                                        key={`${valeur.categorie}-${valeur.value}-${indexValeur}`}
                                                        className="oc-applied-filter-tag"
                                                        onClick={() => handleRemoveValeur(valeur)}
                                                    >
                                                        {valeur?.label || valeur?.value}
                                                        <i className="pi pi-times"></i>
                                                    </Button>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                }
                                // student style without container/header
                                return (
                                    <div className="oc-applied-filters-tags">
                                        {applied.map((valeur, indexValeur) => (
                                            <Button
                                                key={`${valeur.categorie}-${valeur.value}-${indexValeur}`}
                                                className="oc-applied-filter-tag"
                                                onClick={() => handleRemoveValeur(valeur)}
                                            >
                                                {valeur?.label || valeur?.value}
                                                <i className="pi pi-times"></i>
                                            </Button>
                                        ))}
                                    </div>
                                );
                            }

                            // Default variant (existing blue/white buttons)
                            return (
                                <Fragment>
                                    {applied.map((valeur, indexValeur) => (
                                        <Fragment key={`${valeur.categorie}-${valeur.value}-${indexValeur}`}>
                                            <div className='dms-filter-item'>
                                                {/* <div> */}
                                                    <Button 
                                                        label={valeur?.label}
                                                        icon="pi pi-times" 
                                                        iconPos="right"
                                                        className="p-button-rounded p-button-text p-mr-2 dmp-button-style" 
                                                        onClick={(e) => handleRemoveValeur(valeur)} 
                                                    />
                                                {/* </div> */}
                                                {/* <span className='ler-filter-item-value'>{valeur?.label}</span> */}
                                            </div>
                                        </Fragment>
                                    ))}
                                </Fragment>
                            );
                        })()}
                    </div>
                )}
            </div>
        </div>
    );
}

// Memoizing the component to avoid unnecessary re-renders
export const ListeElementsRecherche = memo(ListeElementsRechercheComponent, (prevProps, nextProps) => {
    return (
        prevProps.placeholder === nextProps.placeholder &&
        prevProps.field === nextProps.field &&
        prevProps.icon === nextProps.icon &&
        prevProps.style === nextProps.style &&
        prevProps.canDeleteAll === nextProps.canDeleteAll &&
        JSON.stringify(prevProps.values) === JSON.stringify(nextProps.values)
    );
});